import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CheckoutPage from "../pages/checkout/page";
import LiveOrdersPage from "../pages/live-orders/page";
import ReportsPage from "../pages/reports/page";
import MenuPage from "../pages/menu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/live-orders",
    element: <LiveOrdersPage />,
  },
  {
    path: "/reports",
    element: <ReportsPage />,
  },
  {
    path: "/menu",
    element: <MenuPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;